module.exports = __webpack_public_path__ + "static/media/getty_Images_1204596112_tablet.45d594dd.jpg";